import {
  useCallback, useEffect, useRef, useState,
} from 'react';
import { dontShowServiceDeskTour } from 'helpers/userSessionSettings';

const TOUR_OPEN_DELAY = 400;

const useServiceDeskTour = ({ canReadTickets = false, canCreateTickets = false }) => {
  const serviceDeskRef = useRef(null);
  const reportIssueRef = useRef(null);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [tourOpen, setTourOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(dontShowServiceDeskTour);

  const available = canReadTickets || canCreateTickets;

  const onDropdownOpenChange = useCallback((open) => {
    // Keep the dropdown open while the tour is running.
    if (tourOpen) return;

    setDropdownOpen(open);
  }, [tourOpen]);

  const closeTour = useCallback(() => setTourOpen(false), []);

  useEffect(() => {
    let timer;
    if (dropdownOpen && available && !dontShowAgain) {
      timer = setTimeout(() => setTourOpen(true), TOUR_OPEN_DELAY);
    }

    return () => clearTimeout(timer);
  }, [dropdownOpen, available, dontShowAgain]);

  return {
    serviceDeskRef,
    reportIssueRef,
    dropdownOpen,
    onDropdownOpenChange,
    tourOpen,
    closeTour,
    dontShowAgain,
    setDontShowAgain,
    canReadTickets,
    canCreateTickets,
  };
};

export default useServiceDeskTour;
